import { z } from 'zod';
import { EBloodType } from '@/src/shared/enums/blood-type';
import { EGender } from '@/src/shared/enums/gender';
import { EIdCardVerification } from '@/src/shared/enums/id-card-verification';
import { EMaritalStatus } from '@/src/shared/enums/marital-status';
import { EReligion } from '@/src/shared/enums/religion';

export const SIndividualResponse = z.object({
  id: z.number(),
  profile_image_link: z.string().nullable(),
  id_card_image_link: z.string().nullable(),
  first_name: z.string(),
  last_name: z.string(),
  whatsapp: z.string(),
  nik: z.string().nullable(),
  nickname: z.string(),
  gender: z.number().pipe(z.enum(EGender)),
  birthdate: z.coerce.date(),
  blood_type: z.number().pipe(z.enum(EBloodType)).nullable(),
  id_card_verification: z.number().pipe(z.enum(EIdCardVerification)).nullable(),
  identity_address: z.string().nullable(),
  rt: z.string().nullable(),
  rw: z.string().nullable(),
  kelurahan: z.string().nullable(),
  master_kelurahan_code: z.string().nullable(),
  kecamatan: z.string().nullable(),
  master_kecamatan_code: z.string().nullable(),
  kota_kabupaten: z.string().nullable(),
  master_kota_kabupaten_code: z.string().nullable(),
  provinsi: z.string().nullable(),
  master_provinsi_code: z.string().nullable(),
  agama: z.number().pipe(z.enum(EReligion)).nullable(),
  marital_status: z.number().pipe(z.enum(EMaritalStatus)).nullable(),
  birthplace: z.string().nullable(),
  citizenship: z.string().nullable(),
  bpjs_ketenagakerjaan_number: z.string().nullable(),
  bpjs_number: z.string().nullable(),
  is_active: z.boolean(),
});
export type TIndividualResponse = z.infer<typeof SIndividualResponse>;
